/**
 * Central route map for tenant organization + org-scoped customer APIs.
 * Base URL: `process.env.REACT_APP_API_URL` (see `axiosIntercepture.jsx`).
 * All paths are relative to that base (e.g. `http://localhost:8080/api/`).
 */
export const ORGANIZATION_API = {
  /** POST { tenantId } → flat/tree payload (see organizationService unwrap). */
  FETCH_TREE: "tenant/organization/fetch-tree",
  /** POST { organizationId } → single organization + customers (optional). */
  GET_BY_ID: "tenant/organization/get",
  /** POST body → create organization (returns new id). */
  CREATE: "tenant/organization/create",
  /** POST body → create organization and N customers in one transaction. */
  CREATE_WITH_CUSTOMERS: "tenant/organization/create-with-customers",
  /** POST body + path id → full update. */
  UPDATE: (organizationId) => `tenant/organization/update/${encodeURIComponent(organizationId)}`,
  /** POST { organizationId } → soft/hard delete per backend rules. */
  DELETE: "tenant/organization/delete",
  /** POST { organizationId, newParentOrganizationId } → validated reparent. */
  REPARENT: "tenant/organization/reparent",
  /** POST { tenantId, organizationCode, excludeOrganizationId? } → { available: boolean }. */
  CHECK_CODE: "tenant/organization/check-code",
  /** POST { organizationId, page, pageSize, filters? } → paged customers. */
  CUSTOMERS_LIST: "tenant/organization/customers/list",
  /** POST { organizationId, ...customer } → created customer. */
  CUSTOMERS_CREATE: "tenant/organization/customers/create",
  /** POST { organizationId, ...customer, moduleAccess?, portalAdmin? } → create customer with portal admin. */
  CUSTOMERS_CREATE_WITH_PORTAL_ADMIN: "tenant/organization/customers/create-with-portal-admin",
  /** POST body; path customerId — update customer under org. */
  CUSTOMERS_UPDATE: (customerId) =>
    `tenant/organization/customers/update/${encodeURIComponent(customerId)}`,
  /** POST { organizationId, customerId } → delete. */
  CUSTOMERS_DELETE: "tenant/organization/customers/delete",
};
